<template lang="pug">
.container(ref="container")
    .content(v-if="contents && contents.length" )
        .cards(:style="{ height: `${height}px` }")
            CardImage(
                v-if="image"
                :cardImage="image"
                :altText="cardBodyTitle"
                :height="height"
            )
            CardBody(
                :cardBodyTitle="cardBodyTitle"
                :cardBodySubTitle="cardBodySubTitle"
                :cardBodyText="cardBodyText"
            )
</template>
<script>
//import Components
import { get, debounce, trim } from "lodash";
import CardImage from "./Partials/CardImage.vue";
import CardBody from "./Partials/CardBody";
export default {
  name: "Card",
  data() {
    return {
      maxW: undefined,
    };
  },
  components: {
    CardBody,
    CardImage,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
  },
  computed: {
    height() {
      return this.image.height + "px";
    },
    contents() {
      return get(this.section, "contents", []);
    },
    content() {
      if (this.contents && this.contents.length) return this.contents[0];
      return null;
    },
    cardBodyText() {
      return get(this.content, "text", false);
    },
    cardBodyTitle() {
      return get(this.content, "title", false);
    },
    cardBodySubTitle() {
      return get(this.content, "sub_title", false);
    },
    image() {
      const image = get(this.content, "images.0");

      if (!image || !this.maxW || this.maxW === "undefined") return false;

      const storageRoute = trim(
        `${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        "/"
      );

      let fit =
        get(image, "pivot.fit") || "fit=crop&crop=focalpoint&x=.5&y=.5&z=1";
      const parameters = {
        ...get(fit.match(/x=(?<fx>[0-1]?\.?[0-9]*)/), "groups"),
        ...get(fit.match(/y=(?<fy>[0-1]?\.?[0-9]*)/), "groups"),
        ...get(fit.match(/z=(?<fz>[1-9]+\.?[0-9]*)/), "groups"),
        ...get(fit.match(/w=(?<w>[0-9]+\.?[0-9]*)/), "groups"),
        ...get(fit.match(/h=(?<h>[0-9]+\.?[0-9]*)/), "groups"),
      };
      let { w, h, fz } = parameters;
      if (!fz) fz = 1;

      let width, height, aspectRatio;

      width = image.width / fz;
      height = image.height / fz;
      aspectRatio = width / height;

      if (w && h) {
        aspectRatio = w / h;
        width = Math.min(this.maxW, width);
        height = width / aspectRatio;

        fit = fit
          .replace(/w=([0-9]+\.?[0-9]*)/, `w=${width}`)
          .replace(/h=([0-9]+\.?[0-9]*)/, `h=${height}`);
      } else if (!w && !h) {
        fit += `&w=${Math.min(this.maxW, width)}`;
      }
      return {
        src: `${storageRoute}/images/${image.id}/${image.name}?${fit}`,
        error: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${image.id}/${image.name}?${fit}&preview=blur`,
        width,
        height,
        aspectRatio,
      };
    },
  },
  methods: {},
  mounted() {
    const calculateMaxWidth = () => {
      if (this.$refs.container) {
        const style = getComputedStyle(this.$refs.container);
        this.maxW = this.$refs.container.clientWidth;
        this.maxW -=
          parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
      }
    };

    window.addEventListener("resize", debounce(calculateMaxWidth, 100));
    calculateMaxWidth();
  },
};
</script>
<style lang="sass" scoped>
@import '~@/assets/sass/variables'
@import "~bulma/sass/utilities/mixins"
.cards
    display: flex
    justify-content: space-evenly
    flex-direction: row
    +mobile
        flex-direction: column
    &::v-deep
        .image
            width: 35%
            +mobile
                width: 85%
                margin: auto
            img
                height: auto
        .cardBody
            display: flex
            flex-direction: column
            justify-content: center
            width: 35%
            border: 1px solid #000
            padding: 45px
            text-align: center
            strong
             color: #666
            +mobile
                width: 85%
                margin: auto
</style>
